import script from "./AutoPlayVideo.vue?vue&type=script&lang=ts&setup=true"
export * from "./AutoPlayVideo.vue?vue&type=script&lang=ts&setup=true"

import "./AutoPlayVideo.vue?vue&type=style&index=0&id=40f76898&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f76898"]])

export default __exports__